import { useState } from 'react';

import FileSaver from 'file-saver';

import { DownloadDocumentSpecifiqueUsingGETQueryParams } from 'lib_api/lib/api/gen';

import { useApi } from 'hooks/ApiStoreContext';
import { useHandleBackErrors } from 'hooks/utils/handleBackErrors';
import { RequestStatus } from 'types/RequestStatus';

interface DownloadDocumentSpecifiqueResult {
  downloadStatus: RequestStatus | undefined;
  download: (name: string, hash: string) => Promise<void>;
}

function useDownloadDocumentSpecifique(): DownloadDocumentSpecifiqueResult {
  const [requestStatus, setRequestStatus] = useState<RequestStatus>();
  const behaviourOnError = useHandleBackErrors();
  const { DocumentSpecifiqueControllerApi: api } = useApi();

  const download = async (fileName: string, hash: string) => {
    setRequestStatus(RequestStatus.PENDING);

    const queryParams: DownloadDocumentSpecifiqueUsingGETQueryParams = {
      hash,
      name: fileName,
    };

    const apiCall = api.downloadDocumentSpecifiqueUsingGET(queryParams);

    await apiCall
      .then((result: Response) => {
        // Create dom link to download file
        return result.blob();
      })
      .then((blob: Blob) => {
        FileSaver.saveAs(blob, fileName);
        setRequestStatus(RequestStatus.SUCCESS);
      })
      .catch((errorResponse: Response) => {
        setRequestStatus(RequestStatus.ERROR);
        behaviourOnError(errorResponse, true);
      });
  };

  return {
    downloadStatus: requestStatus,
    download,
  };
}

export default useDownloadDocumentSpecifique;
